import { Component, OnInit, OnDestroy } from '@angular/core';
import { Unit, UnitService } from '../../services/unit.service';
import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { Router } from '@angular/router';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-read-unit',
  templateUrl: './read-unit.component.html',
  styleUrls: ['./read-unit.component.css']
})

export class ReadUnitComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  units:any[] = [];

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Nombre', name: 'name'},
    {title: 'Símbolo', name: 'symbol', sort: false},
    {title: 'Tipo', name: 'type', sort: 'asc'},
    {title: 'Valor', name: 'value', sort: ''},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  sub: Subscription;

  constructor(
    private service: UnitService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
		private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    let subSet = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
      subSet.unsubscribe();
    });

		this.sub = this.service.getUnits().subscribe(tempUnits => {
      //localStorage.units = JSON.stringify(tempUnits.map(({id, ...unit}) => unit ) );
			this.units = [];
			for (const idx in tempUnits) {
        const u = tempUnits[idx];
        if(u.type == 'Tiempo'){
          if(u.name == 'Minuto'){u.value = '60 segundos'};
          if(u.name == 'Hora'){u.value = '60 minutos'};
          if(u.name == 'Día'){u.value = '24 Horas'};
          if(u.name == 'Semana'){u.value = '7 días'};
        }else if(u.type == 'Velocidad'){
          if(+u.value == 1){u.value += ' ' + u.reference}
          else{u.value += ' ' + u.reference.replace('/','s/')};
        }else if(u.type == 'Área' || u.type == 'Volumen Sólido'){
          if(+u.value == 1){u.value += ' ' + u.reference}
          else{u.value += ' ' + u.reference.replace(' ','s ') + 's'};
        }else{
          if(+u.value == 1){u.value += ' ' + u.reference}
          else{u.value += ' ' + u.reference + 's'};
        }
				this.units.push(u);
		  }

			if(localStorage.re_unit__page){
				this.page = +localStorage.re_unit__page;
			}
      this.data = this.units;
			this.length = this.data.length;
			this.onChangeTable(this.config);
    });
    /* let UNITS = JSON.parse(localStorage.units);
    UNITS.map((unit: Unit) => {
      service.addUnit(unit);
    }); */
    
	}

  ngOnInit() {
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  deleteUnit(sid: string) {
    this.service.deleteUnit(sid);
	}

	onCellClick(data: any): any {
		//this.router.navigate(['/vw_employee/' + data.row.id$]);
		console.log('/vw_unit/' + data.row.id)
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate(['/new_unit']);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edit_unit/', data.row.id]);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deleteUnit(data.row.id);
	}

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
		localStorage.re_unit__page = `${page.page}`;
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
